// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.electric-border {
  --electric-light-color: oklch(from var(--electric-border-color) l c h);
  --eb-border-width: 2px;
  position: relative;
  border-radius: inherit;
  overflow: visible;
  isolation: isolate;
}

.eb-svg {
  position: fixed;
  left: -10000px;
  top: -10000px;
  width: 10px;
  height: 10px;
  opacity: 0.001;
  pointer-events: none;
}

.eb-content {
  position: relative;
  border-radius: inherit;
  z-index: 1;
  padding: 12px 2px;
  display: flex;
  align-items: center;
}

.eb-layers {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  z-index: 2;
}

.eb-stroke,
.eb-glow-1,
.eb-glow-2,
.eb-overlay-1,
.eb-overlay-2,
.eb-background-glow {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  box-sizing: border-box;
}

.eb-stroke {
  border: var(--eb-border-width) solid var(--electric-border-color);
}

.eb-glow-1 {
  border: var(--eb-border-width) solid oklch(from var(--electric-border-color) l c h / 0.6);
  opacity: 0.5;
  filter: blur(calc(0.5px + (var(--eb-border-width) * 0.25)));
}

.eb-glow-2 {
  border: var(--eb-border-width) solid var(--electric-light-color);
  opacity: 0.5;
  filter: blur(calc(2px + (var(--eb-border-width) * 0.5)));
}

.eb-background-glow {
  z-index: -1;
  transform: scale(1.08);
  filter: blur(32px);
  opacity: 0.3;
  background: linear-gradient(-30deg, var(--electric-light-color), transparent, var(--electric-border-color));
}
`, "",{"version":3,"sources":["webpack://./src/ElectricBorder.css"],"names":[],"mappings":"AAAA;EACE,sEAAsE;EACtE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;;;;;EAME,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,yFAAyF;EACzF,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,gEAAgE;EAChE,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,2GAA2G;AAC7G","sourcesContent":[".electric-border {\r\n  --electric-light-color: oklch(from var(--electric-border-color) l c h);\r\n  --eb-border-width: 2px;\r\n  position: relative;\r\n  border-radius: inherit;\r\n  overflow: visible;\r\n  isolation: isolate;\r\n}\r\n\r\n.eb-svg {\r\n  position: fixed;\r\n  left: -10000px;\r\n  top: -10000px;\r\n  width: 10px;\r\n  height: 10px;\r\n  opacity: 0.001;\r\n  pointer-events: none;\r\n}\r\n\r\n.eb-content {\r\n  position: relative;\r\n  border-radius: inherit;\r\n  z-index: 1;\r\n  padding: 12px 2px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.eb-layers {\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: inherit;\r\n  pointer-events: none;\r\n  z-index: 2;\r\n}\r\n\r\n.eb-stroke,\r\n.eb-glow-1,\r\n.eb-glow-2,\r\n.eb-overlay-1,\r\n.eb-overlay-2,\r\n.eb-background-glow {\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: inherit;\r\n  pointer-events: none;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.eb-stroke {\r\n  border: var(--eb-border-width) solid var(--electric-border-color);\r\n}\r\n\r\n.eb-glow-1 {\r\n  border: var(--eb-border-width) solid oklch(from var(--electric-border-color) l c h / 0.6);\r\n  opacity: 0.5;\r\n  filter: blur(calc(0.5px + (var(--eb-border-width) * 0.25)));\r\n}\r\n\r\n.eb-glow-2 {\r\n  border: var(--eb-border-width) solid var(--electric-light-color);\r\n  opacity: 0.5;\r\n  filter: blur(calc(2px + (var(--eb-border-width) * 0.5)));\r\n}\r\n\r\n.eb-background-glow {\r\n  z-index: -1;\r\n  transform: scale(1.08);\r\n  filter: blur(32px);\r\n  opacity: 0.3;\r\n  background: linear-gradient(-30deg, var(--electric-light-color), transparent, var(--electric-border-color));\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
